import { call, put, takeLatest, delay, fork, select } from "redux-saga/effects";
import { apiGetNotifications, apiGetUserDetails } from "services";
import { env } from "env";
import { logout, setNotifications, setUser } from "store/user/userSlice";
import { IUserData, NotificationResponse } from "types/userTypes";
import { SagaIterator } from "redux-saga";
import { RootState } from "store";

// Fetch user details
function* fetchUserDetails(): SagaIterator {
    try {
        const userDetails: IUserData = yield call(apiGetUserDetails);

        if (
            userDetails?.userImage &&
            typeof userDetails.userImage !== "string" &&
            "formats" in userDetails.userImage
        ) {
            userDetails.userImage = `${env.BASE_URL}${userDetails.userImage.url}`;
        }

        yield put(setUser(userDetails));
    } catch (error: any) {
        console.error("Error fetching user details:", error);
        yield put(logout(error.message));
        localStorage.clear();
    }
}

// Fetch notifications once
function* fetchNotifications(): SagaIterator {
    try {
        const userNotifications: NotificationResponse = yield call(apiGetNotifications);
        yield put(setNotifications(userNotifications.data));
    } catch (error: any) {
        console.error("Error fetching notifications:", error);
        yield put(logout(error.message));
        localStorage.clear();
    }
}

// Fetch notifications every 5 minutes
function* watchNotificationsSaga(): SagaIterator {
    while (true) {
        const isAuthenticated: boolean = yield select((state: RootState) => !!state.user.userData);

        if (isAuthenticated) {
            yield call(fetchNotifications);
        }
        
        yield delay(300000); // Wait 5 minutes before the next call
    }
}

// Watcher Saga
function* userSaga(): SagaIterator {
    yield takeLatest("user/fetchUserDetails", fetchUserDetails);
    yield takeLatest("user/fetchNotifications", fetchNotifications);

    // Start background task to fetch notifications every 5 minutes
    yield fork(watchNotificationsSaga);
}

export default userSaga;
